import { call } from "redux-saga/effects";

let getInitModule = null;
export function* getModulesTv({productId}) {
  if (!getInitModule) {
    getInitModule = yield call(() => import('./init'));
  }
  //llamada a modulo
  yield call(getInitModule.initModules, {productId})
}